// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import BrowserExtension from 'app/common/lib/BrowserExtension';
import type { Dispatch } from 'redux';
import { ExtensionUI } from 'app/common/react/components/growth/activation/ExtensionUpsell/ExtensionUpsell';
import { setUserState } from 'app/common/redux/actions/nux/updateUser';
import { track } from 'app/common/lib/react/analytics';
import setNuxProgress, { type NuxStep } from 'app/common/redux/actions/nuxProgress';
import {
  NUX_BROWSER_EXT_STEP_STATUS,
  SHOWED,
  COMPLETED,
} from 'app/common/react/components/growth/activation/NuxConst/NuxConst';

type OwnProps = {|
  incrementNuxStep: () => void,
  personalizationCopy: {
    headerText: string,
    subHeaderText: string,
  },
  isRenux?: boolean,
|};

type DispatchProps = {|
  setNuxUpsellProgress: (number) => void,
  dispatchSetNuxStepProgress: (NuxStep) => void,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
|};

export class NuxExtensionUpsell extends Component<Props> {
  componentDidMount() {
    const { dispatchSetNuxStepProgress, isRenux, setNuxUpsellProgress } = this.props;
    if (!isRenux) {
      setNuxUpsellProgress(SHOWED);
    }
    dispatchSetNuxStepProgress('extension');
    track(PCONST.thrift.EventType.VIEW, {
      view: isRenux ? PCONST.thrift.ViewType.REDO_ORIENTATION : PCONST.thrift.ViewType.ORIENTATION,
      viewParameter: PCONST.thrift.ViewParameterType.ORIENTATION_EXTENSION_UPSELL,
    });
  }

  onInstallButtonClicked = () => {
    const { isRenux } = this.props;

    BrowserExtension.handleExtensionInstall(this.incrementStepAndCompleteLoading);

    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.BROWSER,
      element: PCONST.thrift.ElementType.INSTALL_EXTENSION_BUTTON,
      view: isRenux ? PCONST.thrift.ViewType.REDO_ORIENTATION : PCONST.thrift.ViewType.ORIENTATION,
      viewParameter: PCONST.thrift.ViewParameterType.ORIENTATION_EXTENSION_UPSELL,
    });
  };

  onSkipButtonClick = () => {
    const { isRenux } = this.props;
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.BROWSER,
      element: PCONST.thrift.ElementType.SKIP_BUTTON,
      view: isRenux ? PCONST.thrift.ViewType.REDO_ORIENTATION : PCONST.thrift.ViewType.ORIENTATION,
      viewParameter: PCONST.thrift.ViewParameterType.ORIENTATION_EXTENSION_UPSELL,
    });
    this.incrementStepAndCompleteLoading();
  };

  incrementStepAndCompleteLoading = () => {
    const { incrementNuxStep, isRenux, setNuxUpsellProgress } = this.props;
    if (!isRenux) {
      setNuxUpsellProgress(COMPLETED);
    }
    incrementNuxStep();
  };

  render() {
    const {
      personalizationCopy: { headerText, subHeaderText },
    } = this.props;
    return (
      <ExtensionUI
        header={headerText}
        installClick={this.onInstallButtonClicked}
        skipClick={this.onSkipButtonClick}
        subheader={subHeaderText}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>, props: OwnProps): DispatchProps => ({
  setNuxUpsellProgress: (progress) => dispatch(setUserState(NUX_BROWSER_EXT_STEP_STATUS, progress)),
  dispatchSetNuxStepProgress: (step: NuxStep) => dispatch(setNuxProgress(step)),
});

export default connect<Props, OwnProps, _, DispatchProps, _, _>(
  null,
  mapDispatchToProps,
)(NuxExtensionUpsell);
